import { createCommentAPI } from "@/api/apiFactory";
import type { CreateCommentPayload, ICommentAPI } from "@/api/commentApi";
import type { Comment, CommentFilters, CommentSort } from "@/types/Comment";
import type { PaginatedResponse } from "@/types/Pagination";

export class CommentService {
  public api: ICommentAPI;

  constructor(api?: ICommentAPI) {
    this.api = api || createCommentAPI();
  }

  async getComments(
    filters?: CommentFilters,
    sort?: CommentSort,
    limit?: number,
    skip?: number,
  ): Promise<PaginatedResponse<Comment>> {
    return this.api.fetchComments(filters, sort, limit, skip);
  }

  // Convenience method for backward compatibility
  async getCommentsForEntity(
    entityType: "member" | "booking" | "location" | "organisation" | "room",
    entityId: string,
  ): Promise<Array<Comment>> {
    const response = await this.api.fetchComments({ entityType, entityId });
    return response.data;
  }

  async createComment(payload: CreateCommentPayload): Promise<Comment> {
    return this.api.createComment(payload);
  }

  // Legacy method - kept for backward compatibility
  async addCommentToEntity(entityType: string, entityId: string, comment: string, author: any) {
    return this.api.addCommentToEntity(entityType, entityId, comment, author);
  }
}
